// /notify — admin "Notify" panel route (admin#55).
// -----------------------------------------------------------------
// Type 2 (`tour_updated`) / Type 3 (`new_tour`) push-notification
// sends per docs/notification-send-api.md (FCM contract §C3).
// Admin-claim gating is inherited from the `_authenticated` layout
// route (ProtectedRoute → claims.admin !== true redirects to
// /no-access).

import { createFileRoute } from '@tanstack/react-router';

import { NotifyPanel } from '@/components/notify/NotifyPanel';

export const Route = createFileRoute('/_authenticated/notify')({
  component: NotifyPanel,
});
